module.exports = __webpack_public_path__ + "img/pascal_thun_ocular.4081fd74.jpg";